import { ReactNode, useContext } from 'react';
import { MenuContext } from './MenuContext';

export interface NavigationRequest {
    label: string;
    view: ReactNode;
}

export type NavigationDirection = 'forwards' | 'backwards';

export const useMenuContext = () => {
    const context = useContext(MenuContext);
    if (!context) {
        throw new Error('Menu components must be used within a Menu component');
    }
    return context;
};

export const useMenuNavigation = () => {
    const context = useMenuContext();

    return {
        push: context.navigateTo,
        navigateById: context.navigateById,
        goBack: context.goBack,
        reset: context.reset,
        path: context.path,
    };
};
